import React from 'react';
import { ContributionSummary, ProductsList } from '@components/common';
import { PriceString, Tag } from '@fourthwall/components';
export const CancelledOffers = ({ cancelledOffers, cancellations }) => {
    const cancellation = cancellations.at(-1);
    const renderOffer = ({ variant, offer, quantity, price }) => (React.createElement(ProductsList.Item, { key: variant?.id, image: offer.thumbnailImage, offerId: offer?.id, name: offer?.name, variants: variant.attributesDescription, quantity: quantity, price: React.createElement(PriceString, { value: price.value }) }));
    const getTitle = () => {
        if (cancellation?.issuer === 'Supporter') {
            return 'Canceled by supporter';
        }
        if (cancellation?.issuer === 'Creator') {
            return 'Canceled by you';
        }
        return 'Canceled';
    };
    return (React.createElement(ContributionSummary, { title: getTitle(), status: React.createElement(Tag, { label: "Canceled", appearance: "alert" }) },
        React.createElement(ContributionSummary.Section, null,
            React.createElement(ProductsList, { size: "large" }, cancelledOffers.map(renderOffer)))));
};
